// Detects Instagram / Facebook / Messenger embedded browsers (Google blocks OAuth there).
export function detectInAppBrowser(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  if (/Instagram/i.test(ua)) return "instagram";
  if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A|FBSV/i.test(ua)) return "facebook";
  if (/Messenger/i.test(ua)) return "messenger";
  return null;
}

export function isIOS(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return /iPhone|iPad|iPod/i.test(ua);
}

// Best-effort deep link to open the URL in the system browser.
export function externalBrowserUrl(url, ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  const u = new URL(url);
  if (isIOS(ua)) return `x-safari-${u.protocol.replace(":", "")}://${u.host}${u.pathname}${u.search}`;
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=${u.protocol.replace(":", "")};package=com.android.chrome;end`;
}
